export const iconFontAwesomeBuildingsBuildingCircleXmark = (
	<i className="fa-solid fa-building-circle-xmark"></i>
);
